import React, { useState } from 'react';
import { Layout, Menu, Typography } from 'antd';
import {
  FileTextOutlined,
  PhoneOutlined,
  AlertOutlined,
  BarChartOutlined,
} from '@ant-design/icons';
import { usePermission } from '../hooks/usePermission';
import { ScriptLibrary } from './retainiq/ScriptLibrary';
import { OUTREACH_SCRIPT_TABS } from './retainiq/outreachContent';
import { INTERVENTION_SCRIPT_TABS } from './retainiq/interventionContent';
import { RetainIQCallLog } from './retainiq/RetainIQCallLog';
import { RetainIQReports } from './retainiq/RetainIQReports';

const { Sider, Content } = Layout;

type NavKey = 'calllog' | 'outreach' | 'intervention' | 'reports';

const RetainIQ: React.FC = () => {
  const [nav, setNav] = useState<NavKey>('calllog');
  const canReports = usePermission('retain_iq_reports');

  const items = [
    { key: 'calllog' as const, icon: <FileTextOutlined />, label: 'Call log form' },
    { key: 'outreach' as const, icon: <PhoneOutlined />, label: 'Outreach scripts' },
    { key: 'intervention' as const, icon: <AlertOutlined />, label: 'Intervention scripts' },
    ...(canReports
      ? [{ key: 'reports' as const, icon: <BarChartOutlined />, label: 'Reports' }]
      : []),
  ];

  return (
    <div style={{ background: '#fff', minHeight: 'calc(100vh - 64px)' }}>
      <Layout style={{ minHeight: 'calc(100vh - 64px)', background: '#fff' }}>
        <Sider
          width={220}
          style={{
            background: '#fafafa',
            borderRight: '1px solid #f0f0f0',
          }}
          breakpoint="lg"
          collapsedWidth={0}
        >
          <div style={{ padding: '16px 12px' }}>
            <Typography.Text strong style={{ fontSize: 15 }}>
              RetainIQ
            </Typography.Text>
            <div>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                Call toolkit
              </Typography.Text>
            </div>
          </div>
          <Menu
            mode="inline"
            selectedKeys={[nav]}
            items={items.map((it) => ({
              key: it.key,
              icon: it.icon,
              label: it.label,
              onClick: () => setNav(it.key),
            }))}
            style={{ borderRight: 0 }}
          />
        </Sider>
        <Content style={{ padding: 24, overflow: 'auto' }}>
          {nav === 'calllog' && <RetainIQCallLog />}
          {nav === 'outreach' && <ScriptLibrary tabs={OUTREACH_SCRIPT_TABS} title="Outreach call scripts" />}
          {nav === 'intervention' && <ScriptLibrary tabs={INTERVENTION_SCRIPT_TABS} title="Intervention scripts" />}
          {nav === 'reports' && canReports && <RetainIQReports />}
        </Content>
      </Layout>
    </div>
  );
};

export default RetainIQ;
